(function(){
  'use strict';
  if(window.__SHConversionV101)return;
  window.__SHConversionV101=true;
  var mobileQuery=window.matchMedia('(max-width:900px)');
  var purchaseObserver=null;
  var purchaseSeen=new Map();
  function collectCards(root,selector){
    var cards=[];
    if(!root)return cards;
    if(root.matches&&root.matches(selector))cards.push(root);
    if(root.closest){var ancestor=root.closest(selector);if(ancestor&&cards.indexOf(ancestor)===-1)cards.push(ancestor);}
    if(root.querySelectorAll)root.querySelectorAll(selector).forEach(function(card){if(cards.indexOf(card)===-1)cards.push(card);});
    return cards;
  }
  function enableQuickAdd(scope){
    var root=scope||document;
    if(document.body&&document.body.classList.contains('template-cart'))return;
    if(root.matches&&root.matches('[data-quick-add-enabled]'))root.dataset.quickAddEnabled='true';
    if(root.querySelectorAll)root.querySelectorAll('[data-quick-add-enabled]').forEach(function(el){el.dataset.quickAddEnabled='true';});
  }
  function injectUniversalQuick(scope){
    var root=scope||document;
    collectCards(root,'[data-sh-uc-card]').forEach(function(card){
      if(card.classList.contains('is-sold-out')||card.querySelector('[data-sh-uc-quick]'))return;
      var media=card.querySelector('.sh-uc-card__media'),variantId=card.dataset.selectedVariantId;if(!media||!variantId)return;
      var button=document.createElement('button');button.type='button';button.className='sh-uc-card__quick';button.dataset.shUcQuick='';button.dataset.selectedVariantId=variantId;button.setAttribute('aria-label','Quick add');button.innerHTML='<span>Quick add</span>';media.appendChild(button);
    });
  }
  function injectFurnitureQuick(scope){
    var root=scope||document;
    collectCards(root,'.sh-furn__card[data-handle]').forEach(function(card){
      if(card.querySelector('[data-quick-add]')||card.classList.contains('is-sold-out')||card.querySelector('.sh-furn__sold'))return;
      var media=card.querySelector('.sh-furn__media');if(!media)return;
      var button=document.createElement('button');button.type='button';button.className='sh-furn__quick';button.dataset.quickAdd=card.dataset.handle;button.textContent='Quick add';button.setAttribute('aria-label','Quick add');media.appendChild(button);
    });
  }
  function injectDynamicCollectionQuick(scope){
    var root=scope||document;
    [
      {card:'.sh-lec__card[data-handle]',media:'.sh-lec__media',button:'sh-lec__quick-button',sold:'.sh-lec__sold',group:false},
      {card:'.sh-te__card[data-handle]',media:'.sh-te__media',button:'sh-te__quick-button',sold:'.sh-te__sold',group:true},
      {card:'.sh-ha__card[data-handle]',media:'.sh-ha__media',button:'sh-ha__quick-button',sold:'.sh-ha__sold',group:true},
      {card:'.sh-tx__card[data-handle]',media:'.sh-tx__media',button:'sh-tx__quick-button',sold:'.sh-tx__sold',group:true}
    ].forEach(function(cfg){
      collectCards(root,cfg.card).forEach(function(card){
        if(card.querySelector('[data-sh-quick]')||(cfg.sold&&card.querySelector(cfg.sold)))return;
        var media=card.querySelector(cfg.media),handle=card.dataset.handle;if(!media||!handle)return;
        var button=document.createElement('button');button.type='button';button.className=cfg.button;button.dataset.shQuick=handle;
        if(cfg.group&&card.dataset.group)button.dataset.shQuickGroup=card.dataset.group;
        button.textContent='Quick add';button.setAttribute('aria-label','Quick add');media.appendChild(button);
      });
    });
  }
  function earlyEnhance(scope){enableQuickAdd(scope);injectUniversalQuick(scope);injectFurnitureQuick(scope);injectDynamicCollectionQuick(scope);}
  function refreshSummary(summary){
    if(!summary)return;
    summary.removeAttribute('data-sh-summary-locked');
    summary.removeAttribute('data-sh-summary-width');
    summary.style.removeProperty('--sh-summary-height');
  }
  function cloneTemplate(id){var t=document.getElementById(id);return t&&t.content?t.content.cloneNode(true):null;}
  function normalizePaymentCopy(anchor){
    if(!anchor)return;
    var copy=anchor.querySelector('.sh-payment-methods__copy p'),detail=copy&&copy.querySelector('span');
    if(!detail)return;
    detail.style.removeProperty('display');detail.style.removeProperty('margin-top');
    var text=(detail.textContent||'').replace(/^[\s\-–—]+/,'').trim();
    detail.textContent=text?' — '+text:'';
  }
  function convertProductPanels(scope){
    var root=scope||document;if(!root.querySelectorAll)return;
    root.querySelectorAll('.sh-studio .sh-buy-sticky').forEach(function(buy){
      var existingPaymentAnchor=buy.querySelector('.sh-payment-anchor');normalizePaymentCopy(existingPaymentAnchor);
      if(buy.dataset.shConversionV101==='true')return;
      var summary=buy.querySelector('[data-sh-buy-summary]'),title=summary&&summary.querySelector('h1'),tagline=buy.querySelector('.buy__tagline[data-sh-product-tagline]');
      if(summary&&title&&tagline){var copy=tagline.querySelector('.buy__tagline-copy'),text=(copy?copy.textContent:tagline.textContent||'').trim();if(text){var sub=document.createElement('div');sub.className='buy__subtext';sub.setAttribute('data-sh-product-tagline','');sub.textContent=text;title.insertAdjacentElement('afterend',sub);}tagline.remove();refreshSummary(summary);}
      var productBlock=buy.querySelector('.product-block[data-product-blocks],.product-block');if(productBlock&&!productBlock.querySelector('.opt,select,input[type="radio"],input[type="checkbox"]'))productBlock.hidden=true;
      var cta=buy.querySelector('[data-sh-main-cta]');
      var assuranceRail=buy.querySelector('.sh-assurance-proof-rail');
      if(cta&&!assuranceRail){var assurance=cloneTemplate('SHConversionAssuranceTemplate');if(assurance){cta.insertAdjacentElement('afterend',assurance.firstElementChild);assuranceRail=buy.querySelector('.sh-assurance-proof-rail');}}
      var paymentAnchor=buy.querySelector('.sh-payment-anchor');
      if((assuranceRail||cta)&&!paymentAnchor){var payment=cloneTemplate('SHConversionPaymentTemplate');if(payment){(assuranceRail||cta).insertAdjacentElement('afterend',payment.firstElementChild);paymentAnchor=buy.querySelector('.sh-payment-anchor');}}
      if(assuranceRail&&paymentAnchor&&assuranceRail.nextElementSibling!==paymentAnchor){assuranceRail.insertAdjacentElement('afterend',paymentAnchor);}
      normalizePaymentCopy(paymentAnchor);
      if(buy.closest('.sh-studio').querySelector('.sh-product-notice--warning')){var returns=buy.querySelector('[data-sh-conversion-returns]');if(returns){var strong=returns.querySelector('strong'),small=returns.querySelector('small');if(strong)strong.textContent='Product-specific returns';if(small)small.textContent='See policy before ordering';}}
      buy.dataset.shConversionV101='true';
    });
  }
  function syncChat(){var visible=false;purchaseSeen.forEach(function(v){if(v)visible=true;});if(document.body)document.body.classList.toggle('sh-product-purchase-in-view',mobileQuery.matches&&visible);}
  function observePurchase(){
    if(!('IntersectionObserver' in window))return;if(purchaseObserver)purchaseObserver.disconnect();purchaseSeen.clear();
    var targets=[].slice.call(document.querySelectorAll('.sh-studio .sh-payment-anchor,.sh-studio .sh-assurance-proof-rail,.sh-studio .sh-purchase-promise'));
    if(!targets.length){if(document.body)document.body.classList.remove('sh-product-purchase-in-view');return;}
    purchaseObserver=new IntersectionObserver(function(entries){entries.forEach(function(e){purchaseSeen.set(e.target,e.isIntersecting&&e.intersectionRatio>.02);});syncChat();},{threshold:[0,.02,.2],rootMargin:'-56px 0px -16px 0px'});
    targets.forEach(function(t){purchaseSeen.set(t,false);purchaseObserver.observe(t);});syncChat();
  }
  function boot(scope){earlyEnhance(scope||document);convertProductPanels(scope||document);observePurchase();}
  var productPage=document.body&&document.body.classList.contains('template-product');
  var quickCardSelector='[data-sh-uc-card],.sh-furn__card[data-handle],.sh-lec__card[data-handle],.sh-te__card[data-handle],.sh-ha__card[data-handle],.sh-tx__card[data-handle]';
  var quickScopeSelector=quickCardSelector+',[data-quick-add-enabled]';
  var pendingQuickScopes=new Set();
  var quickFrame=0;
  function queueQuickScope(node){
    if(!node||node.nodeType!==1)return;
    var card=node.closest&&node.closest(quickCardSelector);
    var scope=card||node;
    if(!card&&!scope.matches(quickScopeSelector)&&!scope.querySelector(quickScopeSelector))return;
    pendingQuickScopes.add(scope);
    if(quickFrame)return;
    quickFrame=window.requestAnimationFrame(function(){
      quickFrame=0;
      var scopes=Array.from(pendingQuickScopes);
      pendingQuickScopes.clear();
      scopes.forEach(function(scope){
        if(scope.isConnected&&!scopes.some(function(other){return other!==scope&&other.contains(scope);}))earlyEnhance(scope);
      });
    });
  }
  var earlyObserver=new MutationObserver(function(mutations){
    if(!productPage){
      mutations.forEach(function(m){if(m.target&&m.target.nodeType===1)earlyEnhance(m.target);m.addedNodes.forEach(function(node){if(node.nodeType===1)earlyEnhance(node);});});
      return;
    }
    mutations.forEach(function(m){
      var card=m.target&&m.target.closest&&m.target.closest(quickCardSelector);
      if(card)queueQuickScope(card);
      m.addedNodes.forEach(queueQuickScope);
    });
  });
  earlyObserver.observe(document.documentElement,{childList:true,subtree:true});earlyEnhance(document);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){boot(document);},{once:true});else boot(document);
  document.addEventListener('shopify:section:load',function(e){window.requestAnimationFrame(function(){boot(e.target||document);});});
  window.addEventListener('pageshow',function(){window.requestAnimationFrame(function(){boot(document);});});
  if(mobileQuery.addEventListener)mobileQuery.addEventListener('change',syncChat);else if(mobileQuery.addListener)mobileQuery.addListener(syncChat);
})();

(function(){
  'use strict';
  var STYLE_ID='SHCollectionQuickAddParityV102';
  var selector='.sh-lec .sh-lec__quick-button.sh-lec__quick-button,.sh-te .sh-te__quick-button.sh-te__quick-button,.sh-ha .sh-ha__quick-button.sh-ha__quick-button,.sh-furn .sh-furn__quick.sh-furn__quick,.sh-tx .sh-tx__quick-button.sh-tx__quick-button,.sh-pi .sh-pi__quick-button.sh-pi__quick-button';
  var before='.sh-lec .sh-lec__quick-button.sh-lec__quick-button::before,.sh-te .sh-te__quick-button.sh-te__quick-button::before,.sh-ha .sh-ha__quick-button.sh-ha__quick-button::before,.sh-furn .sh-furn__quick.sh-furn__quick::before,.sh-tx .sh-tx__quick-button.sh-tx__quick-button::before,.sh-pi .sh-pi__quick-button.sh-pi__quick-button::before';
  var after='.sh-lec .sh-lec__quick-button.sh-lec__quick-button::after,.sh-te .sh-te__quick-button.sh-te__quick-button::after,.sh-ha .sh-ha__quick-button.sh-ha__quick-button::after,.sh-furn .sh-furn__quick.sh-furn__quick::after,.sh-tx .sh-tx__quick-button.sh-tx__quick-button::after,.sh-pi .sh-pi__quick-button.sh-pi__quick-button::after';
  function install(){
    if(document.getElementById(STYLE_ID)||!document.body)return;
    var style=document.createElement('style');
    style.id=STYLE_ID;
    style.textContent='@media(max-width:749px){'+selector+'{position:absolute!important;z-index:6!important;left:auto!important;right:3px!important;bottom:3px!important;width:34px!important;height:34px!important;min-width:34px!important;min-height:34px!important;padding:0!important;border:0!important;border-radius:50%!important;background:transparent!important;box-shadow:none!important;transform:none!important;opacity:1!important;overflow:visible!important;font-size:0!important;color:transparent!important;-webkit-text-fill-color:transparent!important}'+selector+':hover,'+selector+':focus-visible{background:transparent!important;box-shadow:none!important;transform:none!important}'+before+'{content:""!important;position:absolute!important;top:50%!important;left:50%!important;width:22px!important;height:22px!important;border-radius:50%!important;background:rgba(17,17,15,.76)!important;box-shadow:0 1px 4px rgba(17,17,15,.12)!important;transform:translate(-50%,-50%)!important}'+after+'{content:"+"!important;position:absolute!important;z-index:1!important;top:50%!important;left:50%!important;display:block!important;width:auto!important;height:auto!important;color:#fff!important;-webkit-text-fill-color:#fff!important;font-family:Arial,sans-serif!important;font-size:11px!important;font-weight:400!important;line-height:1!important;transform:translate(-50%,-53%)!important}}';
    document.body.appendChild(style);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',install,{once:true});else install();
  document.addEventListener('shopify:section:load',install);
  window.addEventListener('pageshow',install);
})();

(function(){
  'use strict';
  var STYLE_ID='SHSimplePurchaseSpacingV102';
  function installStyle(){
    if(document.getElementById(STYLE_ID))return;
    var style=document.createElement('style');
    style.id=STYLE_ID;
    style.textContent='.sh-studio .sh-buy-sticky.sh-simple-purchase .sh-buy-summary .buy__subtext{margin-top:8px!important}.sh-studio .sh-buy-sticky.sh-simple-purchase .sh-buy-summary .buy__subtext+.buy__price{margin-top:14px!important}.sh-studio .sh-buy-sticky.sh-simple-purchase>.product-block[hidden]+.cta{margin-top:18px!important}@media(max-width:900px){.sh-studio .sh-buy-sticky.sh-simple-purchase .sh-buy-summary .buy__subtext{margin-top:8px!important}.sh-studio .sh-buy-sticky.sh-simple-purchase .sh-buy-summary .buy__subtext+.buy__price{margin-top:14px!important}.sh-studio .sh-buy-sticky.sh-simple-purchase>.product-block[hidden]+.cta{margin-top:18px!important}}';
    (document.head||document.documentElement).appendChild(style);
  }
  function apply(scope){
    var root=scope||document;if(!root.querySelectorAll)return;
    root.querySelectorAll('.sh-studio .sh-buy-sticky').forEach(function(buy){
      var summary=buy.querySelector('[data-sh-buy-summary]');
      var hasReviews=!!(summary&&summary.querySelector('.buy__meta'));
      var productBlock=buy.querySelector('.product-block[data-product-blocks],.product-block');
      var hasVariantControls=!!(productBlock&&productBlock.querySelector('.opt,select,input[type="radio"],input[type="checkbox"]'));
      var noVariants=!productBlock||productBlock.hidden||!hasVariantControls;
      buy.classList.toggle('sh-simple-purchase',!hasReviews&&noVariants);
    });
  }
  function boot(scope){installStyle();apply(scope||document);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){window.requestAnimationFrame(function(){boot(document);});},{once:true});else window.requestAnimationFrame(function(){boot(document);});
  document.addEventListener('shopify:section:load',function(e){window.requestAnimationFrame(function(){boot(e.target||document);});});
  window.addEventListener('pageshow',function(){window.requestAnimationFrame(function(){boot(document);});});
})();


(function(){
  'use strict';
  function setupProductVideos(scope){
    var root=scope||document;
    if(!root.querySelectorAll)return;
    root.querySelectorAll('[data-sh-gallery-video]').forEach(function(frame){
      if(frame.dataset.shGalleryVideoReady==='true')return;
      var video=frame.querySelector('video');
      var playButton=frame.querySelector('[data-sh-gallery-video-play]');
      if(!video||!playButton)return;
      frame.dataset.shGalleryVideoReady='true';

      function sync(){
        var playing=!video.paused&&!video.ended;
        frame.classList.toggle('is-playing',playing);
        playButton.setAttribute('aria-label',playing?'Pause product video':'Play product video');
      }

      playButton.addEventListener('click',function(event){
        event.preventDefault();
        event.stopPropagation();
        if(video.paused||video.ended){
          var attempt=video.play();
          if(attempt&&typeof attempt.catch==='function')attempt.catch(sync);
        }else{
          video.pause();
        }
      });
      video.addEventListener('play',sync);
      video.addEventListener('pause',sync);
      video.addEventListener('ended',sync);
      sync();

      var slide=frame.closest('[data-sh-inline-slide]');
      if(slide&&window.MutationObserver){
        new MutationObserver(function(){
          if(slide.hidden&&!video.paused)video.pause();
        }).observe(slide,{attributes:true,attributeFilter:['hidden']});
      }
    });
  }

  function boot(scope){
    setupProductVideos(scope||document);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',function(){boot(document);},{once:true});
  }else{
    boot(document);
  }
  document.addEventListener('shopify:section:load',function(event){boot(event.target||document);});
  window.addEventListener('pageshow',function(){boot(document);});
})();
